import axios from 'axios';
import store from '../store/configureStore';
import { ApplicationState } from '../store/rootReducer';
import { getAuth } from './dev-auth';
import { ClientResponse } from '@blazemeter/shared-types/dist/httpclient/HttpFetch';
import { getViewAsUser } from '../utils/bzmUserConfigUtil';
import _ from 'lodash';
import { appendViewAs } from '../utils/urlUtils';

export const getBlazeDataBaseUrl = () => {
  const userConfig = store.getState() as ApplicationState;
  const bzmConfig = userConfig.blazeUserConfig.blazeUserConfig;
  if (bzmConfig) {
    return new URL('/', bzmConfig.config.blazeDataUrl).href;
  }
  return undefined;
};

export const getARBaseUrl = () => {
  const userConfig = store.getState() as ApplicationState;
  const bzmConfig = userConfig.blazeUserConfig.blazeUserConfig;
  if (bzmConfig) {
    return new URL('/', bzmConfig.config.assetRepositoryUrl).href;
  }
  return undefined;
};

export const getDPBaseUrl = () => {
  const userConfig = store.getState() as ApplicationState;
  const bzmConfig = userConfig.blazeUserConfig.blazeUserConfig;
  if (bzmConfig) {
    return new URL('/', bzmConfig.config.dataProfilerUrl).href;
  }
  return undefined;
};

export const dataDesignerFetch = async (
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  url: string,
  // eslint-disable-next-line
  requestBody?: Object,
  params?: { [key: string]: string },
): Promise<ClientResponse> => {
  const baseURL = getBlazeDataBaseUrl();
  if (baseURL) {
    try {
      const result = await axios({
        baseURL,
        url,
        method,
        data: requestBody,
        params,
        withCredentials: true,
        auth: getAuth(),
      });

      return {
        status: result.status,
        statusText: result.statusText,
        body: result.data,
      };
    } catch (e) {
      return {
        status: e.response.status,
        statusText: e.response.statusText,
        body: e.response.data,
      };
    }
  }
  throw new Error('Blaze Data URL is undefined!');
};

/**
 * Client for calling Blaze Data backend - asset repository
 * @param method GET | POST
 * @param url of endpoint on data designer
 * @param requestBody payload
 * @param params query parameters
 */
export const dataDesignerFetchDP = async (
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  url: string,
  // eslint-disable-next-line
  requestBody?: Object,
  params?: { [key: string]: string },
): Promise<ClientResponse> => {
  const baseURL = getDPBaseUrl();
  if (baseURL) {
    try {
      const result = await axios({
        baseURL,
        url,
        method,
        data: requestBody,
        params,
        withCredentials: true,
        auth: getAuth(),
      });
      return {
        status: result.status,
        statusText: result.statusText,
        body: result.data,
      };
    } catch (e) {
      return {
        status: e.response.status,
        statusText: e.response.statusText,
        body: e.response.data,
      };
    }
  }
  throw new Error('Blaze Data URL is undefined!');
};

/**
 * Adds query parameters to the URL.
 * @param params
 */
const addQueryParameters = (url: string) => {
  const viewAsId = getViewAsUser();
  if (!_.isNil(viewAsId)) {
    return appendViewAs(url, viewAsId);
  }
  return url;
};

export const assetRepoFetch = async (
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  url: string,
  // eslint-disable-next-line
  requestBody?: Object,
  params?: { [key: string]: string },
): Promise<ClientResponse> => {
  const baseURL = getARBaseUrl();
  if (baseURL) {
    try {
      const result = await axios({
        baseURL,
        url: addQueryParameters(url),
        method,
        data: requestBody,
        params,
        withCredentials: true,
        auth: getAuth(),
      });

      return {
        status: result.status,
        statusText: result.statusText,
        body: result.data,
      };
    } catch (e) {
      return {
        status: e.response.status,
        statusText: e.response.statusText,
        body: e.response.data,
      };
    }
  }
  throw new Error('Asset Repository URL is undefined!');
};
